import { useStyledSystem, useResponsiveValue } from '@hopper-ui/styled-system';
import { filterDOMProps } from '@react-aria/utils';
import clsx from 'clsx';
import { createContext, forwardRef } from 'react';
import { useContextProps } from 'react-aria-components';
import { jsx } from 'react/jsx-runtime';

// src/Icon.tsx

// css-module:./Icon.module.css#css-module
var Icon_module_default = { "hop-icon": "Icon-module__hop-icon___xRIyH" };
var IconContext = createContext({});
var Icon = forwardRef((props, ref) => {
  var _a;
  [props, ref] = useContextProps(props, ref, IconContext);
  const {
    size: sizeProp = "md",
    src16,
    src24,
    src32,
    style,
    className,
    "aria-label": ariaLabel,
    "aria-hidden": ariaHidden,
    ...rest
  } = useStyledSystem(props);
  const size = (_a = useResponsiveValue(sizeProp)) != null ? _a : "md";
  const sizeMappings = {
    sm: src16,
    md: src24,
    lg: src32
  };
  const As = sizeMappings[size];
  return /* @__PURE__ */ jsx(
    As,
    {
      ref,
      style,
      ...filterDOMProps(rest),
      focusable: "false",
      role: "img",
      "aria-label": ariaLabel,
      "aria-hidden": ariaLabel ? ariaHidden || void 0 : true,
      className: clsx(
        Icon_module_default["hop-icon"],
        className
      )
    }
  );
});
Icon.displayName = "Icon";

export { Icon, IconContext };
